// NPM Modules
import collect from 'collect.js';
import { writable } from 'svelte/store';
// Models
import AdminUserSavedFilter from '@/Models/AdminUserSavedFilter.js';
// Stores
import AuthUserStore from '@/Stores/AuthUserStore.js';

/**
 * Our Store can be used 2 ways in svelte components
 * 1) ($ prefix) $StoreName to reference writable store collection with all collect.js methods available
 * 2) (Direct) StoreName.method() to call a method on the store
 */
const init = () => {
	const { subscribe, set, update } = writable(collect());

	const methods = {
		getSavedFilters() {
			const authUser = AuthUserStore.currentUser();
			authUser.resourceUrl = () => {
				return `${authUser.baseUrl()}/admin_users/current`;
			};
			authUser
				.get()
				.then((result) => {
					set(collect(result.saved_filters));
				})
				.catch((e) => {
					console.error(e);
				});
		},

		saveAdminUserFilter(filter, filterName) {
			let adminUserSavedFilter = new AdminUserSavedFilter();
			return adminUserSavedFilter.create(filter, filterName);
		}
	};

	return {
		subscribe,
		update,
		set,
		...methods
	};
};

export default init();
